/**
 *
 * Mixin
 *
 */

export const NoteContainerMixin = {
  name: 'NoteContainerMixin',

  components: {
    note: () => import('@/components/Note/Note.vue'),
  },

  props: {
    notable: {
      type: Boolean,
      default: () => true,
    },
  },
};
